var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-0",attrs:{"icon":"","loading":_vm.readFilesLoading,"disabled":_vm.disabled},on:{"click":_vm.upload}},[_c('v-icon',[_vm._v("publish")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }